import React from 'react';

const SearchBox = ({ searchfield, searchChange }) => {
	return (
		<div className="pa2" >
			<input 
			className='pa3 ba b--blue bg-lightest-blue w-20'
			type="search"
			placeholder='search avatar'
			onChange={searchChange}
			/>
		</div>
	)
}

export default SearchBox;